var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCornerCoverPink(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "-538.036 -549.556 1435.088 788.56",
    width: "1em",
    height: "1em"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "corner-cover-pink_svg__a",
    x1: 1282.92,
    y1: 366.33,
    x2: 1295.82,
    y2: 366.33,
    gradientUnits: "userSpaceOnUse",
    fill: "#000"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fa95ba"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#de3163"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "corner-cover-pink_svg__b",
    x1: 1336.32,
    y1: 530.18,
    x2: 1344.73,
    y2: 530.18,
    xlinkHref: "#corner-cover-pink_svg__a",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "corner-cover-pink_svg__c",
    x1: 1166.85,
    y1: 509.07,
    x2: 1174.88,
    y2: 509.07,
    xlinkHref: "#corner-cover-pink_svg__a",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "corner-cover-pink_svg__d",
    x1: 1276.61,
    y1: 338.23,
    x2: 1284.95,
    y2: 338.23,
    xlinkHref: "#corner-cover-pink_svg__a",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "corner-cover-pink_svg__e",
    x1: 1450.32,
    y1: 466.59,
    x2: 1462.24,
    y2: 466.59,
    xlinkHref: "#corner-cover-pink_svg__a",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "corner-cover-pink_svg__f",
    x1: 1191.02,
    y1: 390.25,
    x2: 1201.81,
    y2: 390.25,
    xlinkHref: "#corner-cover-pink_svg__a",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "corner-cover-pink_svg__g",
    x1: 1200.49,
    y1: 564.66,
    x2: 1214.26,
    y2: 564.66,
    xlinkHref: "#corner-cover-pink_svg__a",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "corner-cover-pink_svg__h",
    x1: 1259.04,
    y1: 510.83,
    x2: 1266.7,
    y2: 510.83,
    xlinkHref: "#corner-cover-pink_svg__a",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "corner-cover-pink_svg__i",
    x1: 1307,
    y1: 634.42,
    x2: 1321.25,
    y2: 634.42,
    xlinkHref: "#corner-cover-pink_svg__a",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "corner-cover-pink_svg__j",
    x1: 1381.33,
    y1: 454.78,
    x2: 1395.43,
    y2: 454.78,
    xlinkHref: "#corner-cover-pink_svg__a",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "corner-cover-pink_svg__k",
    x1: 1266.74,
    y1: 384.82,
    x2: 1274.22,
    y2: 384.82,
    xlinkHref: "#corner-cover-pink_svg__a",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "corner-cover-pink_svg__l",
    x1: 1267.16,
    y1: 561.78,
    x2: 1280.51,
    y2: 561.78,
    xlinkHref: "#corner-cover-pink_svg__a",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "corner-cover-pink_svg__m",
    x1: 1375.49,
    y1: 536.17,
    x2: 1385.68,
    y2: 536.17,
    xlinkHref: "#corner-cover-pink_svg__a",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "corner-cover-pink_svg__n",
    x1: 1284.61,
    y1: 586.47,
    x2: 1292.86,
    y2: 586.47,
    xlinkHref: "#corner-cover-pink_svg__a",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "corner-cover-pink_svg__o",
    x1: 1414.12,
    y1: 395.55,
    x2: 1423.9,
    y2: 395.55,
    xlinkHref: "#corner-cover-pink_svg__a",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "corner-cover-pink_svg__p",
    x1: 1409.46,
    y1: 527.31,
    x2: 1417.77,
    y2: 527.31,
    xlinkHref: "#corner-cover-pink_svg__a",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "corner-cover-pink_svg__q",
    x1: 1364.25,
    y1: 621.86,
    x2: 1376.45,
    y2: 621.86,
    xlinkHref: "#corner-cover-pink_svg__a",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "corner-cover-pink_svg__r",
    x1: 1185.49,
    y1: 494.35,
    x2: 1196.72,
    y2: 494.35,
    xlinkHref: "#corner-cover-pink_svg__a",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "corner-cover-pink_svg__s",
    x1: 1327.64,
    y1: 500.63,
    x2: 1336.13,
    y2: 500.63,
    xlinkHref: "#corner-cover-pink_svg__a",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "corner-cover-pink_svg__t",
    x1: 1245.84,
    y1: 537.76,
    x2: 1254.05,
    y2: 537.76,
    xlinkHref: "#corner-cover-pink_svg__a",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "corner-cover-pink_svg__u",
    x1: 1203.66,
    y1: 515.16,
    x2: 1218.75,
    y2: 515.16,
    xlinkHref: "#corner-cover-pink_svg__a",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "corner-cover-pink_svg__v",
    x1: 1393.59,
    y1: 501.36,
    x2: 1400.88,
    y2: 501.36,
    xlinkHref: "#corner-cover-pink_svg__a",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "corner-cover-pink_svg__w",
    x1: 1248.56,
    y1: 480.76,
    x2: 1258.82,
    y2: 480.76,
    xlinkHref: "#corner-cover-pink_svg__a",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "corner-cover-pink_svg__x",
    x1: 1261.08,
    y1: 414.59,
    x2: 1276.53,
    y2: 414.59,
    xlinkHref: "#corner-cover-pink_svg__a",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "corner-cover-pink_svg__y",
    x1: 1304.11,
    y1: 607.39,
    x2: 1311.76,
    y2: 607.39,
    xlinkHref: "#corner-cover-pink_svg__a",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "corner-cover-pink_svg__z",
    x1: 1330.73,
    y1: 411.36,
    x2: 1338.56,
    y2: 411.36,
    xlinkHref: "#corner-cover-pink_svg__a",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "corner-cover-pink_svg__A",
    x1: 1416.88,
    y1: 458,
    x2: 1426.36,
    y2: 458,
    xlinkHref: "#corner-cover-pink_svg__a",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "corner-cover-pink_svg__B",
    x1: 1185.21,
    y1: 445.07,
    x2: 1194.33,
    y2: 445.07,
    xlinkHref: "#corner-cover-pink_svg__a",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "corner-cover-pink_svg__C",
    x1: 1218.25,
    y1: 361.53,
    x2: 1225.68,
    y2: 361.53,
    xlinkHref: "#corner-cover-pink_svg__a",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "corner-cover-pink_svg__D",
    x1: 1393.67,
    y1: 563.73,
    x2: 1408.95,
    y2: 563.73,
    xlinkHref: "#corner-cover-pink_svg__a",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "corner-cover-pink_svg__E",
    x1: 1235.04,
    y1: 447.91,
    x2: 1246.68,
    y2: 447.91,
    xlinkHref: "#corner-cover-pink_svg__a",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "corner-cover-pink_svg__F",
    x1: 1440.05,
    y1: 494.51,
    x2: 1449.35,
    y2: 494.51,
    xlinkHref: "#corner-cover-pink_svg__a",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "corner-cover-pink_svg__G",
    x1: 1288.47,
    y1: 497.78,
    x2: 1295.96,
    y2: 497.78,
    xlinkHref: "#corner-cover-pink_svg__a",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "corner-cover-pink_svg__H",
    x1: 1187.53,
    y1: 419.07,
    x2: 1197.12,
    y2: 419.07,
    xlinkHref: "#corner-cover-pink_svg__a",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "corner-cover-pink_svg__I",
    x1: 1333.78,
    y1: 443.65,
    x2: 1342.52,
    y2: 443.65,
    xlinkHref: "#corner-cover-pink_svg__a",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "corner-cover-pink_svg__J",
    x1: 1159.2,
    y1: 470.07,
    x2: 1171.22,
    y2: 470.07,
    xlinkHref: "#corner-cover-pink_svg__a",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "corner-cover-pink_svg__K",
    x1: 1339.57,
    y1: 383.7,
    x2: 1350.8,
    y2: 383.7,
    xlinkHref: "#corner-cover-pink_svg__a",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "corner-cover-pink_svg__L",
    x1: 1360.43,
    y1: 504.51,
    x2: 1367.58,
    y2: 504.51,
    xlinkHref: "#corner-cover-pink_svg__a",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "corner-cover-pink_svg__M",
    x1: 1300.67,
    y1: 551.19,
    x2: 1311.74,
    y2: 551.19,
    xlinkHref: "#corner-cover-pink_svg__a",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "corner-cover-pink_svg__N",
    x1: 1332.35,
    y1: 342.83,
    x2: 1340.22,
    y2: 342.83,
    xlinkHref: "#corner-cover-pink_svg__a",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "corner-cover-pink_svg__O",
    x1: 1235.4,
    y1: 417.91,
    x2: 1245.43,
    y2: 417.91,
    xlinkHref: "#corner-cover-pink_svg__a",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "corner-cover-pink_svg__P",
    x1: 1391.72,
    y1: 423.99,
    x2: 1398.99,
    y2: 423.99,
    xlinkHref: "#corner-cover-pink_svg__a",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "corner-cover-pink_svg__Q",
    x1: 1211.66,
    y1: 431.77,
    x2: 1219.41,
    y2: 431.77,
    xlinkHref: "#corner-cover-pink_svg__a",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "corner-cover-pink_svg__R",
    x1: 1343.44,
    y1: 594.83,
    x2: 1352.41,
    y2: 594.83,
    xlinkHref: "#corner-cover-pink_svg__a",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "corner-cover-pink_svg__S",
    x1: 1442.26,
    y1: 519.45,
    x2: 1454.51,
    y2: 519.45,
    xlinkHref: "#corner-cover-pink_svg__a",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "corner-cover-pink_svg__T",
    x1: 1358.64,
    y1: 356.72,
    x2: 1370.8,
    y2: 356.72,
    xlinkHref: "#corner-cover-pink_svg__a",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "corner-cover-pink_svg__U",
    x1: 1413.5,
    y1: 485.42,
    x2: 1426.15,
    y2: 485.42,
    xlinkHref: "#corner-cover-pink_svg__a",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "corner-cover-pink_svg__V",
    x1: 1436.3,
    y1: 432.6,
    x2: 1445.34,
    y2: 432.6,
    xlinkHref: "#corner-cover-pink_svg__a",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "corner-cover-pink_svg__W",
    x1: 1278.22,
    y1: 473.44,
    x2: 1286.2,
    y2: 473.44,
    xlinkHref: "#corner-cover-pink_svg__a",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "corner-cover-pink_svg__X",
    x1: 1231.11,
    y1: 578.08,
    x2: 1241.28,
    y2: 578.08,
    xlinkHref: "#corner-cover-pink_svg__a",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "corner-cover-pink_svg__Y",
    x1: 1365.65,
    y1: 475.08,
    x2: 1380.64,
    y2: 475.08,
    xlinkHref: "#corner-cover-pink_svg__a",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "corner-cover-pink_svg__Z",
    x1: 1164.85,
    y1: 415.29,
    x2: 1171.6,
    y2: 415.29,
    xlinkHref: "#corner-cover-pink_svg__a",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "corner-cover-pink_svg__aa",
    x1: 1328.16,
    y1: 621.38,
    x2: 1343.72,
    y2: 621.38,
    xlinkHref: "#corner-cover-pink_svg__a",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "corner-cover-pink_svg__ab",
    x1: 1297.21,
    y1: 440.88,
    x2: 1310.96,
    y2: 440.88,
    xlinkHref: "#corner-cover-pink_svg__a",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "corner-cover-pink_svg__ac",
    x1: 1277.23,
    y1: 533.92,
    x2: 1288.61,
    y2: 533.92,
    xlinkHref: "#corner-cover-pink_svg__a",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "corner-cover-pink_svg__ad",
    x1: 1428.27,
    y1: 551,
    x2: 1441.28,
    y2: 551,
    xlinkHref: "#corner-cover-pink_svg__a",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "corner-cover-pink_svg__ae",
    x1: 1239.44,
    y1: 377.91,
    x2: 1251.37,
    y2: 377.91,
    xlinkHref: "#corner-cover-pink_svg__a",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "corner-cover-pink_svg__af",
    x1: 1194.4,
    y1: 468.97,
    x2: 1205.28,
    y2: 468.97,
    xlinkHref: "#corner-cover-pink_svg__a",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "corner-cover-pink_svg__ag",
    x1: 1338.86,
    y1: 556.83,
    x2: 1350.92,
    y2: 556.83,
    xlinkHref: "#corner-cover-pink_svg__a",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "corner-cover-pink_svg__ah",
    x1: 1253.36,
    y1: 596.35,
    x2: 1262.98,
    y2: 596.35,
    xlinkHref: "#corner-cover-pink_svg__a",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "corner-cover-pink_svg__ai",
    x1: 1363.25,
    y1: 566.36,
    x2: 1374.06,
    y2: 566.36,
    xlinkHref: "#corner-cover-pink_svg__a",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "corner-cover-pink_svg__aj",
    x1: 1331.66,
    y1: 473.21,
    x2: 1339.52,
    y2: 473.21,
    xlinkHref: "#corner-cover-pink_svg__a",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "corner-cover-pink_svg__ak",
    x1: 1228.77,
    y1: 503.47,
    x2: 1241.41,
    y2: 503.47,
    xlinkHref: "#corner-cover-pink_svg__a",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "corner-cover-pink_svg__al",
    x1: 1215.25,
    y1: 542.44,
    x2: 1226.14,
    y2: 542.44,
    xlinkHref: "#corner-cover-pink_svg__a",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "corner-cover-pink_svg__am",
    x1: 1248.12,
    y1: 347.73,
    x2: 1260.26,
    y2: 347.73,
    xlinkHref: "#corner-cover-pink_svg__a",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "corner-cover-pink_svg__an",
    x1: 1221.44,
    y1: 395.85,
    x2: 1228.52,
    y2: 395.85,
    xlinkHref: "#corner-cover-pink_svg__a",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "corner-cover-pink_svg__ao",
    x1: 1297.84,
    y1: 399.61,
    x2: 1305.14,
    y2: 399.61,
    xlinkHref: "#corner-cover-pink_svg__a",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "corner-cover-pink_svg__ap",
    x1: 1218.63,
    y1: 475.31,
    x2: 1232.14,
    y2: 475.31,
    xlinkHref: "#corner-cover-pink_svg__a",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "corner-cover-pink_svg__aq",
    x1: 1270.87,
    y1: 446.62,
    x2: 1279.97,
    y2: 446.62,
    xlinkHref: "#corner-cover-pink_svg__a",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "corner-cover-pink_svg__ar",
    x1: 1377.07,
    y1: 378.12,
    x2: 1384.04,
    y2: 378.12,
    xlinkHref: "#corner-cover-pink_svg__a",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "corner-cover-pink_svg__as",
    x1: 1152.28,
    y1: 443.43,
    x2: 1158.9,
    y2: 443.43,
    xlinkHref: "#corner-cover-pink_svg__a",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "corner-cover-pink_svg__at",
    x1: 1406.98,
    y1: 591.1,
    x2: 1416.72,
    y2: 591.1,
    xlinkHref: "#corner-cover-pink_svg__a",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "corner-cover-pink_svg__au",
    x1: 1179.91,
    y1: 537.07,
    x2: 1194.44,
    y2: 537.07,
    xlinkHref: "#corner-cover-pink_svg__a",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "corner-cover-pink_svg__av",
    x1: 1317.58,
    y1: 369.98,
    x2: 1328.59,
    y2: 369.98,
    xlinkHref: "#corner-cover-pink_svg__a",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "corner-cover-pink_svg__aw",
    x1: 1314.11,
    y1: 576.42,
    x2: 1323.45,
    y2: 576.42,
    xlinkHref: "#corner-cover-pink_svg__a",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "corner-cover-pink_svg__ax",
    x1: 1301.48,
    y1: 341.68,
    x2: 1316.49,
    y2: 341.68,
    xlinkHref: "#corner-cover-pink_svg__a",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "corner-cover-pink_svg__ay",
    x1: 1377.09,
    y1: 592.98,
    x2: 1385.93,
    y2: 592.98,
    xlinkHref: "#corner-cover-pink_svg__a",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "corner-cover-pink_svg__az",
    x1: 1303.7,
    y1: 520.89,
    x2: 1317.76,
    y2: 520.89,
    xlinkHref: "#corner-cover-pink_svg__a",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "corner-cover-pink_svg__aA",
    x1: 1273.8,
    y1: 619.73,
    x2: 1286.28,
    y2: 619.73,
    xlinkHref: "#corner-cover-pink_svg__a",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "corner-cover-pink_svg__aB",
    x1: 1365.88,
    y1: 411.49,
    x2: 1373.92,
    y2: 411.49,
    xlinkHref: "#corner-cover-pink_svg__a",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "corner-cover-pink_svg__aC",
    x1: 160,
    y1: 248.2,
    x2: 646.38,
    y2: 248.2,
    xlinkHref: "#corner-cover-pink_svg__a",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "corner-cover-pink_svg__aD",
    x1: 803.06,
    y1: 417.32,
    x2: 1288.3,
    y2: 417.32,
    xlinkHref: "#corner-cover-pink_svg__a",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "corner-cover-pink_svg__aE",
    x1: 157.8,
    y1: 106.46,
    x2: 170.7,
    y2: 106.46,
    xlinkHref: "#corner-cover-pink_svg__a",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "corner-cover-pink_svg__aF",
    x1: 211.2,
    y1: 270.31,
    x2: 219.61,
    y2: 270.31,
    xlinkHref: "#corner-cover-pink_svg__a",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "corner-cover-pink_svg__aG",
    x1: 41.73,
    y1: 249.2,
    x2: 49.76,
    y2: 249.2,
    xlinkHref: "#corner-cover-pink_svg__a",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "corner-cover-pink_svg__aH",
    x1: 151.49,
    y1: 78.36,
    x2: 159.83,
    y2: 78.36,
    xlinkHref: "#corner-cover-pink_svg__a",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "corner-cover-pink_svg__aI",
    x1: 325.2,
    y1: 206.72,
    x2: 337.12,
    y2: 206.72,
    xlinkHref: "#corner-cover-pink_svg__a",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "corner-cover-pink_svg__aJ",
    x1: 65.89,
    y1: 130.37,
    x2: 76.69,
    y2: 130.37,
    xlinkHref: "#corner-cover-pink_svg__a",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "corner-cover-pink_svg__aK",
    x1: 75.37,
    y1: 304.79,
    x2: 89.14,
    y2: 304.79,
    xlinkHref: "#corner-cover-pink_svg__a",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "corner-cover-pink_svg__aL",
    x1: 133.92,
    y1: 250.96,
    x2: 141.58,
    y2: 250.96,
    xlinkHref: "#corner-cover-pink_svg__a",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "corner-cover-pink_svg__aM",
    x1: 181.88,
    y1: 374.55,
    x2: 196.13,
    y2: 374.55,
    xlinkHref: "#corner-cover-pink_svg__a",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "corner-cover-pink_svg__aN",
    x1: 256.21,
    y1: 194.9,
    x2: 270.31,
    y2: 194.9,
    xlinkHref: "#corner-cover-pink_svg__a",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "corner-cover-pink_svg__aO",
    x1: 141.62,
    y1: 124.94,
    x2: 149.1,
    y2: 124.94,
    xlinkHref: "#corner-cover-pink_svg__a",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "corner-cover-pink_svg__aP",
    x1: 142.04,
    y1: 301.91,
    x2: 155.39,
    y2: 301.91,
    xlinkHref: "#corner-cover-pink_svg__a",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "corner-cover-pink_svg__aQ",
    x1: 250.37,
    y1: 276.3,
    x2: 260.56,
    y2: 276.3,
    xlinkHref: "#corner-cover-pink_svg__a",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "corner-cover-pink_svg__aR",
    x1: 159.49,
    y1: 326.6,
    x2: 167.74,
    y2: 326.6,
    xlinkHref: "#corner-cover-pink_svg__a",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "corner-cover-pink_svg__aS",
    x1: 289,
    y1: 135.68,
    x2: 298.78,
    y2: 135.68,
    xlinkHref: "#corner-cover-pink_svg__a",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "corner-cover-pink_svg__aT",
    x1: 284.34,
    y1: 267.44,
    x2: 292.64,
    y2: 267.44,
    xlinkHref: "#corner-cover-pink_svg__a",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "corner-cover-pink_svg__aU",
    x1: 239.13,
    y1: 361.99,
    x2: 251.33,
    y2: 361.99,
    xlinkHref: "#corner-cover-pink_svg__a",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "corner-cover-pink_svg__aV",
    x1: 60.37,
    y1: 234.48,
    x2: 71.6,
    y2: 234.48,
    xlinkHref: "#corner-cover-pink_svg__a",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "corner-cover-pink_svg__aW",
    x1: 202.52,
    y1: 240.76,
    x2: 211.01,
    y2: 240.76,
    xlinkHref: "#corner-cover-pink_svg__a",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "corner-cover-pink_svg__aX",
    x1: 120.72,
    y1: 277.89,
    x2: 128.93,
    y2: 277.89,
    xlinkHref: "#corner-cover-pink_svg__a",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "corner-cover-pink_svg__aY",
    x1: 78.54,
    y1: 255.29,
    x2: 93.63,
    y2: 255.29,
    xlinkHref: "#corner-cover-pink_svg__a",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "corner-cover-pink_svg__aZ",
    x1: 268.47,
    y1: 241.49,
    x2: 275.76,
    y2: 241.49,
    xlinkHref: "#corner-cover-pink_svg__a",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "corner-cover-pink_svg__ba",
    x1: 123.44,
    y1: 220.88,
    x2: 133.7,
    y2: 220.88,
    xlinkHref: "#corner-cover-pink_svg__a",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "corner-cover-pink_svg__bb",
    x1: 135.96,
    y1: 154.72,
    x2: 151.41,
    y2: 154.72,
    xlinkHref: "#corner-cover-pink_svg__a",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "corner-cover-pink_svg__bc",
    x1: 178.99,
    y1: 347.52,
    x2: 186.64,
    y2: 347.52,
    xlinkHref: "#corner-cover-pink_svg__a",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "corner-cover-pink_svg__bd",
    x1: 205.6,
    y1: 151.49,
    x2: 213.44,
    y2: 151.49,
    xlinkHref: "#corner-cover-pink_svg__a",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "corner-cover-pink_svg__be",
    x1: 291.76,
    y1: 198.13,
    x2: 301.24,
    y2: 198.13,
    xlinkHref: "#corner-cover-pink_svg__a",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "corner-cover-pink_svg__bf",
    x1: 60.09,
    y1: 185.2,
    x2: 69.21,
    y2: 185.2,
    xlinkHref: "#corner-cover-pink_svg__a",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "corner-cover-pink_svg__bg",
    x1: 93.13,
    y1: 101.66,
    x2: 100.56,
    y2: 101.66,
    xlinkHref: "#corner-cover-pink_svg__a",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "corner-cover-pink_svg__bh",
    x1: 268.55,
    y1: 303.86,
    x2: 283.83,
    y2: 303.86,
    xlinkHref: "#corner-cover-pink_svg__a",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "corner-cover-pink_svg__bi",
    x1: 109.92,
    y1: 188.04,
    x2: 121.56,
    y2: 188.04,
    xlinkHref: "#corner-cover-pink_svg__a",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "corner-cover-pink_svg__bj",
    x1: 314.93,
    y1: 234.64,
    x2: 324.23,
    y2: 234.64,
    xlinkHref: "#corner-cover-pink_svg__a",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "corner-cover-pink_svg__bk",
    x1: 163.35,
    y1: 237.91,
    x2: 170.84,
    y2: 237.91,
    xlinkHref: "#corner-cover-pink_svg__a",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "corner-cover-pink_svg__bl",
    x1: 62.41,
    y1: 159.19,
    x2: 72,
    y2: 159.19,
    xlinkHref: "#corner-cover-pink_svg__a",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "corner-cover-pink_svg__bm",
    x1: 208.65,
    y1: 183.78,
    x2: 217.4,
    y2: 183.78,
    xlinkHref: "#corner-cover-pink_svg__a",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "corner-cover-pink_svg__bn",
    x1: 34.08,
    y1: 210.2,
    x2: 46.1,
    y2: 210.2,
    xlinkHref: "#corner-cover-pink_svg__a",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "corner-cover-pink_svg__bo",
    x1: 214.45,
    y1: 123.83,
    x2: 225.68,
    y2: 123.83,
    xlinkHref: "#corner-cover-pink_svg__a",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "corner-cover-pink_svg__bp",
    x1: 235.31,
    y1: 244.64,
    x2: 242.46,
    y2: 244.64,
    xlinkHref: "#corner-cover-pink_svg__a",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "corner-cover-pink_svg__bq",
    x1: 175.55,
    y1: 291.32,
    x2: 186.62,
    y2: 291.32,
    xlinkHref: "#corner-cover-pink_svg__a",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "corner-cover-pink_svg__br",
    x1: 207.23,
    y1: 82.95,
    x2: 215.1,
    y2: 82.95,
    xlinkHref: "#corner-cover-pink_svg__a",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "corner-cover-pink_svg__bs",
    x1: 110.28,
    y1: 158.04,
    x2: 120.31,
    y2: 158.04,
    xlinkHref: "#corner-cover-pink_svg__a",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "corner-cover-pink_svg__bt",
    x1: 266.6,
    y1: 164.12,
    x2: 273.87,
    y2: 164.12,
    xlinkHref: "#corner-cover-pink_svg__a",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "corner-cover-pink_svg__bu",
    x1: 86.54,
    y1: 171.9,
    x2: 94.29,
    y2: 171.9,
    xlinkHref: "#corner-cover-pink_svg__a",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "corner-cover-pink_svg__bv",
    x1: 218.31,
    y1: 334.96,
    x2: 227.29,
    y2: 334.96,
    xlinkHref: "#corner-cover-pink_svg__a",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "corner-cover-pink_svg__bw",
    x1: 317.14,
    y1: 259.57,
    x2: 329.38,
    y2: 259.57,
    xlinkHref: "#corner-cover-pink_svg__a",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "corner-cover-pink_svg__bx",
    x1: 233.52,
    y1: 96.84,
    x2: 245.68,
    y2: 96.84,
    xlinkHref: "#corner-cover-pink_svg__a",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "corner-cover-pink_svg__by",
    x1: 288.38,
    y1: 225.55,
    x2: 301.03,
    y2: 225.55,
    xlinkHref: "#corner-cover-pink_svg__a",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "corner-cover-pink_svg__bz",
    x1: 311.18,
    y1: 172.73,
    x2: 320.22,
    y2: 172.73,
    xlinkHref: "#corner-cover-pink_svg__a",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "corner-cover-pink_svg__bA",
    x1: 153.1,
    y1: 213.56,
    x2: 161.08,
    y2: 213.56,
    xlinkHref: "#corner-cover-pink_svg__a",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "corner-cover-pink_svg__bB",
    x1: 105.99,
    y1: 318.21,
    x2: 116.16,
    y2: 318.21,
    xlinkHref: "#corner-cover-pink_svg__a",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "corner-cover-pink_svg__bC",
    x1: 240.53,
    y1: 215.21,
    x2: 255.52,
    y2: 215.21,
    xlinkHref: "#corner-cover-pink_svg__a",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "corner-cover-pink_svg__bD",
    x1: 39.73,
    y1: 155.42,
    x2: 46.48,
    y2: 155.42,
    xlinkHref: "#corner-cover-pink_svg__a",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "corner-cover-pink_svg__bE",
    x1: 203.03,
    y1: 361.5,
    x2: 218.6,
    y2: 361.5,
    xlinkHref: "#corner-cover-pink_svg__a",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "corner-cover-pink_svg__bF",
    x1: 172.09,
    y1: 181.01,
    x2: 185.84,
    y2: 181.01,
    xlinkHref: "#corner-cover-pink_svg__a",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "corner-cover-pink_svg__bG",
    x1: 152.11,
    y1: 274.05,
    x2: 163.49,
    y2: 274.05,
    xlinkHref: "#corner-cover-pink_svg__a",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "corner-cover-pink_svg__bH",
    x1: 303.15,
    y1: 291.13,
    x2: 316.16,
    y2: 291.13,
    xlinkHref: "#corner-cover-pink_svg__a",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "corner-cover-pink_svg__bI",
    x1: 114.31,
    y1: 118.04,
    x2: 126.24,
    y2: 118.04,
    xlinkHref: "#corner-cover-pink_svg__a",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "corner-cover-pink_svg__bJ",
    x1: 69.28,
    y1: 209.1,
    x2: 80.16,
    y2: 209.1,
    xlinkHref: "#corner-cover-pink_svg__a",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "corner-cover-pink_svg__bK",
    x1: 213.74,
    y1: 296.96,
    x2: 225.8,
    y2: 296.96,
    xlinkHref: "#corner-cover-pink_svg__a",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "corner-cover-pink_svg__bL",
    x1: 128.24,
    y1: 336.48,
    x2: 137.85,
    y2: 336.48,
    xlinkHref: "#corner-cover-pink_svg__a",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "corner-cover-pink_svg__bM",
    x1: 238.13,
    y1: 306.49,
    x2: 248.94,
    y2: 306.49,
    xlinkHref: "#corner-cover-pink_svg__a",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "corner-cover-pink_svg__bN",
    x1: 206.54,
    y1: 213.34,
    x2: 214.4,
    y2: 213.34,
    xlinkHref: "#corner-cover-pink_svg__a",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "corner-cover-pink_svg__bO",
    x1: 103.65,
    y1: 243.6,
    x2: 116.29,
    y2: 243.6,
    xlinkHref: "#corner-cover-pink_svg__a",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "corner-cover-pink_svg__bP",
    x1: 90.13,
    y1: 282.57,
    x2: 101.02,
    y2: 282.57,
    xlinkHref: "#corner-cover-pink_svg__a",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "corner-cover-pink_svg__bQ",
    x1: 123,
    y1: 87.85,
    x2: 135.14,
    y2: 87.85,
    xlinkHref: "#corner-cover-pink_svg__a",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "corner-cover-pink_svg__bR",
    x1: 96.32,
    y1: 135.98,
    x2: 103.4,
    y2: 135.98,
    xlinkHref: "#corner-cover-pink_svg__a",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "corner-cover-pink_svg__bS",
    x1: 172.72,
    y1: 139.74,
    x2: 180.02,
    y2: 139.74,
    xlinkHref: "#corner-cover-pink_svg__a",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "corner-cover-pink_svg__bT",
    x1: 93.5,
    y1: 215.44,
    x2: 107.02,
    y2: 215.44,
    xlinkHref: "#corner-cover-pink_svg__a",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "corner-cover-pink_svg__bU",
    x1: 145.75,
    y1: 186.75,
    x2: 154.85,
    y2: 186.75,
    xlinkHref: "#corner-cover-pink_svg__a",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "corner-cover-pink_svg__bV",
    x1: 251.95,
    y1: 118.25,
    x2: 258.92,
    y2: 118.25,
    xlinkHref: "#corner-cover-pink_svg__a",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "corner-cover-pink_svg__bW",
    x1: 27.15,
    y1: 183.56,
    x2: 33.78,
    y2: 183.56,
    xlinkHref: "#corner-cover-pink_svg__a",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "corner-cover-pink_svg__bX",
    x1: 281.86,
    y1: 331.23,
    x2: 291.6,
    y2: 331.23,
    xlinkHref: "#corner-cover-pink_svg__a",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "corner-cover-pink_svg__bY",
    x1: 54.79,
    y1: 277.2,
    x2: 69.32,
    y2: 277.2,
    xlinkHref: "#corner-cover-pink_svg__a",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "corner-cover-pink_svg__bZ",
    x1: 192.46,
    y1: 110.11,
    x2: 203.47,
    y2: 110.11,
    xlinkHref: "#corner-cover-pink_svg__a",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "corner-cover-pink_svg__ca",
    x1: 188.99,
    y1: 316.55,
    x2: 198.33,
    y2: 316.55,
    xlinkHref: "#corner-cover-pink_svg__a",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "corner-cover-pink_svg__cb",
    x1: 176.36,
    y1: 81.81,
    x2: 191.37,
    y2: 81.81,
    xlinkHref: "#corner-cover-pink_svg__a",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "corner-cover-pink_svg__cc",
    x1: 251.97,
    y1: 333.11,
    x2: 260.8,
    y2: 333.11,
    xlinkHref: "#corner-cover-pink_svg__a",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "corner-cover-pink_svg__cd",
    x1: 178.58,
    y1: 261.02,
    x2: 192.64,
    y2: 261.02,
    xlinkHref: "#corner-cover-pink_svg__a",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "corner-cover-pink_svg__ce",
    x1: 148.67,
    y1: 359.86,
    x2: 161.16,
    y2: 359.86,
    xlinkHref: "#corner-cover-pink_svg__a",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "corner-cover-pink_svg__cf",
    x1: 240.76,
    y1: 151.62,
    x2: 248.8,
    y2: 151.62,
    xlinkHref: "#corner-cover-pink_svg__a",
    fill: "#000"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "corner-cover-pink_svg__cls-2",
    d: "M1287.42 372.24a26.31 26.31 0 004.46-.5c2.7-.8 3.48-3.19 3.89-5.71.59-3.66-4.24-5.86-8.2-5.62-6.78.42-5.57 10.3-.15 11.83z",
    transform: "translate(-565.189 -554.456)",
    fill: "url(#corner-cover-pink_svg__a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "corner-cover-pink_svg__cls-3",
    d: "M1336.4 531.08a18.6 18.6 0 001.73 2.57c1.35 1.39 3.06 1.11 4.73.56 2.44-.81 2.24-4.47.83-6.81-2.42-4.03-8.08-.1-7.29 3.68z",
    transform: "translate(-565.189 -554.456)",
    fill: "url(#corner-cover-pink_svg__b)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "corner-cover-pink_svg__cls-4",
    d: "M1167.39 511.25a15.53 15.53 0 002.34 1.66c1.62.77 3 0 4.28-1.07 1.84-1.49.48-4.6-1.52-6.16-3.41-2.68-7.02 2.56-5.1 5.57z",
    transform: "translate(-565.189 -554.456)",
    fill: "url(#corner-cover-pink_svg__c)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "corner-cover-pink_svg__cls-5",
    d: "M1278.08 341.5a16.57 16.57 0 002.82.76c1.83.16 2.87-1.1 3.72-2.53 1.24-2.07-1.16-4.56-3.62-5.36-4.21-1.37-5.81 4.92-2.92 7.13z",
    transform: "translate(-565.189 -554.456)",
    fill: "url(#corner-cover-pink_svg__d)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "corner-cover-pink_svg__cls-6",
    d: "M1451.43 470.3a23.2 23.2 0 003.69 2.08c2.5.88 4.41-.52 6.11-2.22 2.48-2.47 0-6.82-3.16-8.81-5.42-3.43-9.91 4.82-6.64 8.95z",
    transform: "translate(-565.189 -554.456)",
    fill: "url(#corner-cover-pink_svg__e)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "corner-cover-pink_svg__cls-7",
    d: "M1193.13 394.63a23.1 23.1 0 003.69.8c2.37.08 3.63-1.61 4.63-3.51 1.46-2.76-1.8-5.81-5-6.68-5.54-1.49-7.2 6.76-3.32 9.39z",
    transform: "translate(-565.189 -554.456)",
    fill: "url(#corner-cover-pink_svg__f)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "corner-cover-pink_svg__cls-8",
    d: "M1205 570.94a27.64 27.64 0 004.77-.35c2.91-.74 3.84-3.25 4.39-5.93.78-3.88-4.28-6.42-8.51-6.33-7.24.16-6.31 10.76-.65 12.61z",
    transform: "translate(-565.189 -554.456)",
    fill: "url(#corner-cover-pink_svg__g)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "corner-cover-pink_svg__cls-9",
    d: "M1260.05 513.55a14.92 14.92 0 002.49 1c1.66.36 2.76-.67 3.7-1.88 1.37-1.76-.54-4.32-2.7-5.33-3.7-1.72-5.89 3.85-3.49 6.21z",
    transform: "translate(-565.189 -554.456)",
    fill: "url(#corner-cover-pink_svg__h)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "corner-cover-pink_svg__cls-10",
    d: "M1310.65 640.68c.65.33 4.9.38 4.95.37 3.1-.31 4.44-2.74 5.4-5.4 1.4-3.86-3.39-7.25-7.75-7.8-7.46-.94-8.14 10.06-2.6 12.83z",
    transform: "translate(-565.189 -554.456)",
    fill: "url(#corner-cover-pink_svg__i)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "corner-cover-pink_svg__cls-11",
    d: "M1381.33 454.71c0 .77 1.94 4.83 2 4.88 1.75 2.8 4.7 2.93 7.68 2.6 4.33-.47 5.3-6.63 3.78-11-2.64-7.58-13.43-3.05-13.46 3.52z",
    transform: "translate(-565.189 -554.456)",
    fill: "url(#corner-cover-pink_svg__j)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "corner-cover-pink_svg__cls-12",
    d: "M1266.75 384.27a15.59 15.59 0 00.74 2.71c.75 1.59 2.3 1.84 3.9 1.86 2.32 0 3.22-3.18 2.69-5.61-.91-4.16-6.91-2.43-7.33 1.04z",
    transform: "translate(-565.189 -554.456)",
    fill: "url(#corner-cover-pink_svg__k)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "corner-cover-pink_svg__cls-13",
    d: "M1270.41 567.56a27.28 27.28 0 004.63.47c2.91-.21 4.22-2.46 5.2-4.92 1.41-3.58-3-6.88-7.06-7.51-6.97-1.07-7.88 9.22-2.77 11.96z",
    transform: "translate(-565.189 -554.456)",
    fill: "url(#corner-cover-pink_svg__l)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "corner-cover-pink_svg__cls-14",
    d: "M1375.54 537a23 23 0 002 3.22c1.56 1.78 3.66 1.53 5.72 1 3-.83 3-5.29 1.41-8.23-2.76-5.06-9.86-.62-9.13 4.01z",
    transform: "translate(-565.189 -554.456)",
    fill: "url(#corner-cover-pink_svg__m)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "corner-cover-pink_svg__cls-15",
    d: "M1285.68 589.4a16.28 16.28 0 002.69 1.1c1.78.39 3-.72 4-2 1.49-1.89-.57-4.65-2.89-5.75-4-1.91-6.38 4.1-3.8 6.65z",
    transform: "translate(-565.189 -554.456)",
    fill: "url(#corner-cover-pink_svg__n)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "corner-cover-pink_svg__cls-16",
    d: "M1414.43 397.46a20 20 0 002.49 2.53c1.81 1.29 3.68.61 5.45-.36 2.57-1.41 1.58-5.5-.5-7.84-3.57-4.03-9.12 1.58-7.44 5.67z",
    transform: "translate(-565.189 -554.456)",
    fill: "url(#corner-cover-pink_svg__o)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "corner-cover-pink_svg__cls-17",
    d: "M1411 530.64a16.51 16.51 0 002.83.67c1.82.11 2.82-1.17 3.62-2.61 1.18-2.1-1.28-4.51-3.75-5.23-4.21-1.25-5.63 5.05-2.7 7.17z",
    transform: "translate(-565.189 -554.456)",
    fill: "url(#corner-cover-pink_svg__p)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "corner-cover-pink_svg__cls-18",
    d: "M1364.25 621.7a25.2 25.2 0 001.65 4.26c1.48 2.44 4 2.59 6.61 2.34 3.76-.36 4.67-5.68 3.41-9.51-2.17-6.57-11.57-2.79-11.67 2.91z",
    transform: "translate(-565.189 -554.456)",
    fill: "url(#corner-cover-pink_svg__q)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "corner-cover-pink_svg__cls-19",
    d: "M1186 497a23.5 23.5 0 003.1 2.59c2.19 1.26 4.23.29 6.13-1 2.76-1.89 1.19-6.4-1.43-8.83-4.45-4.14-10.11 2.82-7.8 7.24z",
    transform: "translate(-565.189 -554.456)",
    fill: "url(#corner-cover-pink_svg__r)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "corner-cover-pink_svg__cls-20",
    d: "M1327.77 501.82a18.8 18.8 0 001.91 2.46c1.45 1.3 3.14.9 4.78.23 2.39-1 1.94-4.62.36-6.88-2.7-3.86-8.09.46-7.05 4.19z",
    transform: "translate(-565.189 -554.456)",
    fill: "url(#corner-cover-pink_svg__s)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "corner-cover-pink_svg__cls-21",
    d: "M1246.32 539.88a16.54 16.54 0 002.35 1.77c1.64.85 3.09.07 4.42-.94 1.94-1.47.65-4.7-1.34-6.37-3.4-2.88-7.29 2.38-5.43 5.54z",
    transform: "translate(-565.189 -554.456)",
    fill: "url(#corner-cover-pink_svg__t)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "corner-cover-pink_svg__cls-22",
    d: "M1206 520.81c.59.51 5 1.69 5 1.69 3.29.5 5.31-1.66 7-4.15 2.47-3.62-1.59-8.39-6-10.11-7.42-2.95-11 8.25-6 12.57z",
    transform: "translate(-565.189 -554.456)",
    fill: "url(#corner-cover-pink_svg__u)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "corner-cover-pink_svg__cls-23",
    d: "M1394.21 503.54a14 14 0 002.22 1.34c1.51.59 2.71-.23 3.78-1.24 1.57-1.46.13-4.17-1.76-5.45-3.25-2.19-6.16 2.81-4.24 5.35z",
    transform: "translate(-565.189 -554.456)",
    fill: "url(#corner-cover-pink_svg__v)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "corner-cover-pink_svg__cls-24",
    d: "M1250.89 485.11a20 20 0 003.54.49c2.24-.08 3.32-1.76 4.14-3.63 1.19-2.71-2.11-5.37-5.21-6-5.36-.97-6.36 6.89-2.47 9.14z",
    transform: "translate(-565.189 -554.456)",
    fill: "url(#corner-cover-pink_svg__w)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "corner-cover-pink_svg__cls-25",
    d: "M1263.54 420.46c.6.51 5.11 1.63 5.16 1.64 3.37.45 5.41-1.79 7.1-4.37 2.47-3.75-1.77-8.56-6.26-10.24-7.69-2.89-11.19 8.63-6 12.97z",
    transform: "translate(-565.189 -554.456)",
    fill: "url(#corner-cover-pink_svg__x)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "corner-cover-pink_svg__cls-26",
    d: "M1304.55 609.34a16.53 16.53 0 002.17 1.68c1.53.79 2.88.08 4.13-.86 1.82-1.35.63-4.37-1.21-5.94-3.15-2.71-6.8 2.17-5.09 5.12z",
    transform: "translate(-565.189 -554.456)",
    fill: "url(#corner-cover-pink_svg__y)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "corner-cover-pink_svg__cls-27",
    d: "M1330.86 412.53a16.13 16.13 0 001.8 2.23c1.35 1.18 2.9.79 4.41.15 2.18-.93 1.72-4.29.23-6.35-2.54-3.56-7.45.54-6.44 3.97z",
    transform: "translate(-565.189 -554.456)",
    fill: "url(#corner-cover-pink_svg__z)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "corner-cover-pink_svg__cls-28",
    d: "M1418.43 461.63a18.28 18.28 0 003.18 1c2.07.26 3.3-1.13 4.32-2.73 1.49-2.31-1.14-5.23-3.91-6.23-4.73-1.75-6.8 5.33-3.59 7.96z",
    transform: "translate(-565.189 -554.456)",
    fill: "url(#corner-cover-pink_svg__A)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "corner-cover-pink_svg__cls-29",
    d: "M1185.8 447.53a19.06 19.06 0 002.65 1.89c1.85.89 3.43 0 4.88-1.18 2.1-1.68.57-5.22-1.68-7-3.87-3.1-8.01 2.84-5.85 6.29z",
    transform: "translate(-565.189 -554.456)",
    fill: "url(#corner-cover-pink_svg__B)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "corner-cover-pink_svg__cls-30",
    d: "M1220.7 364.92a14.4 14.4 0 002.58-.19c1.57-.4 2.07-1.76 2.36-3.2.42-2.09-2.31-3.47-4.6-3.41-3.91.09-3.4 5.81-.34 6.8z",
    transform: "translate(-565.189 -554.456)",
    fill: "url(#corner-cover-pink_svg__C)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "corner-cover-pink_svg__cls-31",
    d: "M1397.81 570.54c.71.32 5.26.24 5.32.23 3.3-.44 4.65-3.09 5.6-6 1.37-4.18-3.88-7.64-8.56-8.09-8.03-.68-8.38 11.08-2.36 13.86z",
    transform: "translate(-565.189 -554.456)",
    fill: "url(#corner-cover-pink_svg__D)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "corner-cover-pink_svg__cls-32",
    d: "M1235.41 450.18a22.94 22.94 0 003 3c2.16 1.54 4.38.73 6.48-.43 3.06-1.68 1.89-6.54-.59-9.33-4.3-4.78-10.89 1.89-8.89 6.76z",
    transform: "translate(-565.189 -554.456)",
    fill: "url(#corner-cover-pink_svg__E)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "corner-cover-pink_svg__cls-33",
    d: "M1442.06 498.4a18.71 18.71 0 003.2.53c2 0 3-1.52 3.84-3.2 1.14-2.43-1.79-4.92-4.59-5.53-4.81-1.06-5.9 6.07-2.45 8.2z",
    transform: "translate(-565.189 -554.456)",
    fill: "url(#corner-cover-pink_svg__F)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "corner-cover-pink_svg__cls-34",
    d: "M1288.72 499.29a16.05 16.05 0 001.93 1.9c1.4 1 2.82.43 4.16-.33 2-1.11 1.16-4.22-.46-6-2.77-3.03-6.95 1.32-5.63 4.43z",
    transform: "translate(-565.189 -554.456)",
    fill: "url(#corner-cover-pink_svg__G)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "corner-cover-pink_svg__cls-35",
    d: "M1189.3 422.88a19.11 19.11 0 003.25.81c2.1.14 3.27-1.33 4.22-3 1.37-2.41-1.45-5.21-4.29-6.07-4.87-1.47-6.56 5.79-3.18 8.26z",
    transform: "translate(-565.189 -554.456)",
    fill: "url(#corner-cover-pink_svg__H)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "corner-cover-pink_svg__cls-36",
    d: "M1333.88 444.72a18.59 18.59 0 001.88 2.61c1.45 1.4 3.21 1.05 4.93.42 2.5-.91 2.17-4.7.63-7.09-2.65-4.1-8.38.17-7.44 4.06z",
    transform: "translate(-565.189 -554.456)",
    fill: "url(#corner-cover-pink_svg__I)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "corner-cover-pink_svg__cls-37",
    d: "M1160.17 473.61a24.2 24.2 0 003.63 2.26c2.49 1 4.48-.32 6.28-1.95 2.62-2.38.31-6.89-2.79-9.05-5.29-3.71-10.23 4.42-7.12 8.74z",
    transform: "translate(-565.189 -554.456)",
    fill: "url(#corner-cover-pink_svg__J)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "corner-cover-pink_svg__cls-38",
    d: "M1339.71 385.12a24.71 24.71 0 002.44 3.33c1.87 1.79 4.12 1.32 6.33.5 3.19-1.19 2.75-6.06.75-9.11-3.43-5.23-10.76.28-9.52 5.28z",
    transform: "translate(-565.189 -554.456)",
    fill: "url(#corner-cover-pink_svg__K)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "corner-cover-pink_svg__cls-39",
    d: "M1360.58 505.67a14.12 14.12 0 001.7 2c1.26 1 2.66.64 4 0 2-.9 1.45-3.94 0-5.77-2.35-3.14-6.71.68-5.7 3.77z",
    transform: "translate(-565.189 -554.456)",
    fill: "url(#corner-cover-pink_svg__L)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "corner-cover-pink_svg__cls-40",
    d: "M1304.82 556.29a23.34 23.34 0 003.81-.63c2.28-.8 2.84-2.88 3.09-5.06.35-3.17-3.89-4.85-7.28-4.47-5.81.65-4.3 9.08.38 10.16z",
    transform: "translate(-565.189 -554.456)",
    fill: "url(#corner-cover-pink_svg__M)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "corner-cover-pink_svg__cls-41",
    d: "M1332.45 343.84a16.41 16.41 0 001.73 2.32c1.31 1.25 2.89.91 4.43.33 2.24-.85 1.9-4.26.49-6.39-2.43-3.64-7.54.25-6.65 3.74z",
    transform: "translate(-565.189 -554.456)",
    fill: "url(#corner-cover-pink_svg__N)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "corner-cover-pink_svg__cls-42",
    d: "M1235.41 416.74a21.13 21.13 0 00.73 3.71c.85 2.21 2.91 2.7 5 2.87 3.12.25 4.63-4 4.16-7.26-.77-5.67-8.98-3.94-9.89.68z",
    transform: "translate(-565.189 -554.456)",
    fill: "url(#corner-cover-pink_svg__O)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "corner-cover-pink_svg__cls-43",
    d: "M1391.72 423.58a15.88 15.88 0 00.79 2.61c.77 1.52 2.28 1.72 3.84 1.69 2.25 0 3-3.17 2.45-5.51-.99-4.01-6.8-2.17-7.08 1.21z",
    transform: "translate(-565.189 -554.456)",
    fill: "url(#corner-cover-pink_svg__P)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "corner-cover-pink_svg__cls-44",
    d: "M1211.66 431.68a16.42 16.42 0 001 2.7c.94 1.55 2.56 1.64 4.21 1.48 2.38-.23 3-3.61 2.15-6.05-1.33-4.17-7.3-1.75-7.36 1.87z",
    transform: "translate(-565.189 -554.456)",
    fill: "url(#corner-cover-pink_svg__Q)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "corner-cover-pink_svg__cls-45",
    d: "M1344.51 597.91a19.17 19.17 0 002.88 1.3c1.93.49 3.26-.68 4.42-2.06 1.69-2-.45-5.09-2.94-6.37-4.27-2.2-7.08 4.22-4.36 7.13z",
    transform: "translate(-565.189 -554.456)",
    fill: "url(#corner-cover-pink_svg__R)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "corner-cover-pink_svg__cls-46",
    d: "M1443.06 522.75a25.59 25.59 0 003.56 2.55c2.48 1.18 4.6 0 6.54-1.6 2.83-2.26.77-7-2.26-9.43-5.19-4.13-10.75 3.86-7.84 8.48z",
    transform: "translate(-565.189 -554.456)",
    fill: "url(#corner-cover-pink_svg__S)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "corner-cover-pink_svg__cls-47",
    d: "M1362.19 362.2a23.69 23.69 0 004.23 0c2.62-.46 3.6-2.61 4.25-4.93.95-3.37-3.35-5.95-7.08-6.14-6.41-.32-6.28 9.07-1.4 11.07z",
    transform: "translate(-565.189 -554.456)",
    fill: "url(#corner-cover-pink_svg__T)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "corner-cover-pink_svg__cls-48",
    d: "M1416 490.55a25.08 25.08 0 004.32.95c2.77.11 4.26-1.86 5.44-4.09 1.73-3.22-2.08-6.81-5.85-7.85-6.5-1.77-8.48 7.85-3.91 10.99z",
    transform: "translate(-565.189 -554.456)",
    fill: "url(#corner-cover-pink_svg__U)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "corner-cover-pink_svg__cls-49",
    d: "M1437.82 436.1a18.71 18.71 0 003 .88c2 .22 3.13-1.12 4.09-2.65 1.38-2.23-1.16-5-3.81-5.9-4.49-1.57-6.37 5.21-3.28 7.67z",
    transform: "translate(-565.189 -554.456)",
    fill: "url(#corner-cover-pink_svg__V)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "corner-cover-pink_svg__cls-50",
    d: "M1278.49 475.05a17.49 17.49 0 002.06 2c1.49 1 3 .45 4.43-.36 2.08-1.19 1.22-4.5-.5-6.38-2.96-3.2-7.4 1.43-5.99 4.74z",
    transform: "translate(-565.189 -554.456)",
    fill: "url(#corner-cover-pink_svg__W)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "corner-cover-pink_svg__cls-51",
    d: "M1232.47 581.71a20 20 0 003.32 1.33c2.2.46 3.65-.92 4.89-2.53 1.81-2.35-.75-5.72-3.63-7-4.92-2.33-7.79 5.09-4.58 8.2z",
    transform: "translate(-565.189 -554.456)",
    fill: "url(#corner-cover-pink_svg__X)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "corner-cover-pink_svg__cls-52",
    d: "M1369.25 481.54c.67.37 5.14.58 5.2.58 3.27-.22 4.76-2.72 5.88-5.48 1.62-4-3.3-7.75-7.86-8.49-7.82-1.28-8.94 10.28-3.22 13.39z",
    transform: "translate(-565.189 -554.456)",
    fill: "url(#corner-cover-pink_svg__Y)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "corner-cover-pink_svg__cls-53",
    d: "M1164.86 414.74a13.9 13.9 0 00.63 2.45c.65 1.45 2 1.7 3.49 1.73 2.1.05 3-2.83 2.51-5-.76-3.79-6.2-2.32-6.63.82z",
    transform: "translate(-565.189 -554.456)",
    fill: "url(#corner-cover-pink_svg__Z)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "corner-cover-pink_svg__cls-54",
    d: "M1333.87 628.54c.77.18 5.31-.78 5.36-.8 3.23-1.08 4.07-4 4.45-7.06.57-4.44-5.35-6.89-10.13-6.43-8.17.75-6.24 12.67.32 14.29z",
    transform: "translate(-565.189 -554.456)",
    fill: "url(#corner-cover-pink_svg__aa)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "corner-cover-pink_svg__cls-55",
    d: "M1298.54 445.22c.45.56 4.23 2.32 4.27 2.34 2.9 1 5.08-.66 7-2.64 2.82-2.88-.1-7.85-3.77-10.11-6.27-3.87-11.33 5.7-7.5 10.41z",
    transform: "translate(-565.189 -554.456)",
    fill: "url(#corner-cover-pink_svg__ab)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    className: "corner-cover-pink_svg__cls-56",
    d: "M1278.6 537.84a23.3 23.3 0 003.66 1.63c2.45.62 4.13-.87 5.59-2.62 2.13-2.56-.59-6.45-3.76-8.06-5.42-2.79-8.94 5.43-5.49 9.05z",
    transform: "translate(-565.189 -554.456)",
    fill: "url(#corner-cover-pink_svg__ac)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    className: "corner-cover-pink_svg__cls-57",
    d: "M1429.91 555.56a28.41 28.41 0 004.22 1.8c2.81.64 4.7-1.09 6.33-3.12 2.38-3-.81-7.35-4.45-9.13-6.25-3.05-10.12 6.38-6.1 10.45z",
    transform: "translate(-565.189 -554.456)",
    fill: "url(#corner-cover-pink_svg__ad)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    className: "corner-cover-pink_svg__cls-58",
    d: "M1239.44 376.86a26.61 26.61 0 001.08 4.36c1.14 2.57 3.6 3 6.15 3.11 3.71.12 5.26-4.95 4.51-8.84-1.29-6.67-10.92-4.15-11.74 1.37z",
    transform: "translate(-565.189 -554.456)",
    fill: "url(#corner-cover-pink_svg__ae)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    className: "corner-cover-pink_svg__cls-59",
    d: "M1195 471.62a23 23 0 003 2.47c2.14 1.19 4.1.22 5.92-1.06 2.64-1.86 1.07-6.21-1.49-8.52-4.43-3.98-9.8 2.83-7.43 7.11z",
    transform: "translate(-565.189 -554.456)",
    fill: "url(#corner-cover-pink_svg__af)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    className: "corner-cover-pink_svg__cls-60",
    d: "M1338.86 556.15a26.76 26.76 0 001.31 4.33c1.29 2.52 3.79 2.86 6.37 2.81 3.73-.08 5-5.26 4.07-9.14-1.61-6.65-11.21-3.61-11.75 2z",
    transform: "translate(-565.189 -554.456)",
    fill: "url(#corner-cover-pink_svg__ag)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    className: "corner-cover-pink_svg__cls-61",
    d: "M1253.36 595.63a22.17 22.17 0 00.94 3.49c1 2 3 2.38 5 2.4 3 0 4.15-4.08 3.48-7.2-1.14-5.32-8.86-3.15-9.42 1.31z",
    transform: "translate(-565.189 -554.456)",
    fill: "url(#corner-cover-pink_svg__ah)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    className: "corner-cover-pink_svg__cls-62",
    d: "M1363.44 568a23.17 23.17 0 002.48 3.08c1.87 1.63 4 1.09 6.08.2 3-1.28 2.37-5.92.32-8.75-3.52-4.89-10.32.72-8.88 5.47z",
    transform: "translate(-565.189 -554.456)",
    fill: "url(#corner-cover-pink_svg__ai)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    className: "corner-cover-pink_svg__cls-63",
    d: "M1332.15 475.28a15.5 15.5 0 002.26 1.67c1.58.79 3 0 4.22-1 1.84-1.43.56-4.5-1.36-6.08-3.27-2.67-6.95 2.42-5.12 5.41z",
    transform: "translate(-565.189 -554.456)",
    fill: "url(#corner-cover-pink_svg__aj)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    className: "corner-cover-pink_svg__cls-64",
    d: "M1228.77 502.88a26.11 26.11 0 001.45 4.51c1.38 2.63 4 2.94 6.71 2.84 3.92-.14 5.19-5.6 4.12-9.65-1.84-6.95-11.82-3.58-12.28 2.3z",
    transform: "translate(-565.189 -554.456)",
    fill: "url(#corner-cover-pink_svg__ak)"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    className: "corner-cover-pink_svg__cls-65",
    d: "M1217.79 547.09a21.64 21.64 0 003.77.48c2.38-.12 3.49-1.93 4.33-3.92 1.22-2.89-2.31-5.66-5.61-6.25-5.67-1.01-6.61 7.37-2.49 9.69z",
    transform: "translate(-565.189 -554.456)",
    fill: "url(#corner-cover-pink_svg__al)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    className: "corner-cover-pink_svg__cls-66",
    d: "M1248.65 350.47a24.35 24.35 0 003.28 2.9c2.34 1.43 4.57.44 6.67-.91 3-2 1.48-6.9-1.29-9.61-4.73-4.64-11.07 2.73-8.66 7.62z",
    transform: "translate(-565.189 -554.456)",
    fill: "url(#corner-cover-pink_svg__am)"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    className: "corner-cover-pink_svg__cls-67",
    d: "M1221.77 397.5a14.08 14.08 0 001.94 1.66c1.38.81 2.67.21 3.88-.6 1.75-1.17.79-4-.85-5.58-2.81-2.66-6.42 1.7-4.97 4.52z",
    transform: "translate(-565.189 -554.456)",
    fill: "url(#corner-cover-pink_svg__an)"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    className: "corner-cover-pink_svg__cls-68",
    d: "M1300 402.92a14.58 14.58 0 002.54-.05c1.57-.3 2.13-1.61 2.5-3 .53-2-2.07-3.53-4.32-3.61-3.81-.13-3.63 5.51-.72 6.66z",
    transform: "translate(-565.189 -554.456)",
    fill: "url(#corner-cover-pink_svg__ao)"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    className: "corner-cover-pink_svg__cls-69",
    d: "M1220.81 480.47a28 28 0 004.52 1.41c3 .37 4.72-1.6 6.19-3.87 2.14-3.29-1.6-7.47-5.53-8.92-6.75-2.49-9.74 7.61-5.18 11.38z",
    transform: "translate(-565.189 -554.456)",
    fill: "url(#corner-cover-pink_svg__ap)"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    className: "corner-cover-pink_svg__cls-70",
    d: "M1271 447.76a19.42 19.42 0 002 2.7c1.52 1.45 3.35 1.08 5.13.41 2.59-1 2.23-4.91.61-7.38-2.83-4.24-8.74.23-7.74 4.27z",
    transform: "translate(-565.189 -554.456)",
    fill: "url(#corner-cover-pink_svg__aq)"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    className: "corner-cover-pink_svg__cls-71",
    d: "M1377.34 379.61a15.19 15.19 0 001.84 1.72c1.33.86 2.63.32 3.85-.42 1.78-1.08 1-3.94-.58-5.55-2.66-2.74-6.45 1.4-5.11 4.25z",
    transform: "translate(-565.189 -554.456)",
    fill: "url(#corner-cover-pink_svg__ar)"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    className: "corner-cover-pink_svg__cls-72",
    d: "M1152.36 444.29a14.9 14.9 0 001.45 2c1.11 1 2.44.76 3.74.26 1.88-.72 1.59-3.58.4-5.37-2.05-3.11-6.34.18-5.59 3.11z",
    transform: "translate(-565.189 -554.456)",
    fill: "url(#corner-cover-pink_svg__as)"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    className: "corner-cover-pink_svg__cls-73",
    d: "M1407 590.77a19.93 19.93 0 001.19 3.44c1.11 2 3.14 2.2 5.21 2.07 3-.17 3.9-4.39 3-7.49-1.54-5.31-9.16-2.56-9.4 1.98z",
    transform: "translate(-565.189 -554.456)",
    fill: "url(#corner-cover-pink_svg__at)"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    className: "corner-cover-pink_svg__cls-74",
    d: "M1180.07 538.82c.18.76 3.07 4.31 3.11 4.35 2.39 2.34 5.33 1.77 8.19.74 4.16-1.5 3.65-7.8 1.1-11.79-4.36-6.82-13.93.21-12.4 6.7z",
    transform: "translate(-565.189 -554.456)",
    fill: "url(#corner-cover-pink_svg__au)"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    className: "corner-cover-pink_svg__cls-75",
    d: "M1317.76 371.58a23.67 23.67 0 002.51 3.16c1.89 1.68 4.08 1.14 6.19.25 3.08-1.28 2.46-6 .4-8.92-3.54-4.98-10.49.68-9.1 5.51z",
    transform: "translate(-565.189 -554.456)",
    fill: "url(#corner-cover-pink_svg__av)"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    className: "corner-cover-pink_svg__cls-76",
    d: "M1317 580.66a18.15 18.15 0 003.25-.1c2-.41 2.7-2.09 3.15-3.88.65-2.61-2.71-4.49-5.58-4.55-4.96-.13-4.64 7.11-.82 8.53z",
    transform: "translate(-565.189 -554.456)",
    fill: "url(#corner-cover-pink_svg__aw)"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    className: "corner-cover-pink_svg__cls-77",
    d: "M1302 344.8c.32.73 3.86 3.73 3.91 3.76 2.83 1.9 5.65.78 8.32-.78 3.87-2.27 2.19-8.47-1.09-12-5.61-5.98-13.86 2.83-11.14 9.02z",
    transform: "translate(-565.189 -554.456)",
    fill: "url(#corner-cover-pink_svg__ax)"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    className: "corner-cover-pink_svg__cls-78",
    d: "M1377.77 595.52a18.67 18.67 0 002.64 1.72c1.81.77 3.3-.18 4.64-1.36 2-1.72.32-5.06-1.93-6.7-3.86-2.79-7.59 3.12-5.35 6.34z",
    transform: "translate(-565.189 -554.456)",
    fill: "url(#corner-cover-pink_svg__ay)"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    className: "corner-cover-pink_svg__cls-79",
    d: "M1303.83 522.39c.15.74 2.86 4.26 2.89 4.3 2.26 2.33 5.12 1.86 7.92.93 4.07-1.34 3.75-7.47 1.39-11.39-4.03-6.73-13.51-.17-12.2 6.16z",
    transform: "translate(-565.189 -554.456)",
    fill: "url(#corner-cover-pink_svg__az)"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    className: "corner-cover-pink_svg__cls-80",
    d: "M1274.07 621.79a26.13 26.13 0 003 3.45c2.22 1.81 4.66 1.09 7 0 3.42-1.6 2.5-6.91 0-10.09-4.22-5.46-11.8 1.25-10 6.64z",
    transform: "translate(-565.189 -554.456)",
    fill: "url(#corner-cover-pink_svg__aA)"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    className: "corner-cover-pink_svg__cls-81",
    d: "M1368.55 415.16a17.39 17.39 0 002.78-.22c1.7-.45 2.23-1.91 2.54-3.48.45-2.27-2.51-3.74-5-3.67-4.22.12-3.64 6.31-.32 7.37z",
    transform: "translate(-565.189 -554.456)",
    fill: "url(#corner-cover-pink_svg__aB)"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    className: "corner-cover-pink_svg__cls-82",
    d: "M264.5 129c-44.83 36.4-92.69 77.78-102.67 134.65-8.91 50.8 15.77 102.63 51.24 140.07 64.43 68 167.6 97.36 257.55 71.19S632.45 367.2 644.84 274.34C655.81 192.15 607.11 64 528.09 24 437.22-22 330.51 75.41 264.5 129z",
    transform: "translate(-565.189 -554.456)",
    fill: "url(#corner-cover-pink_svg__aC)"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    className: "corner-cover-pink_svg__cls-83",
    d: "M1129.09 253.25c-44.57-36.71-94.61-75.42-152.34-73.92-51.56 1.33-97.45 35.81-127.12 78-53.88 76.67-62.19 183.57-18.7 266.55s137.68 137.26 231.15 131c82.73-5.55 198.68-78.7 222.22-164.08 27.07-98.21-89.58-183.48-155.21-237.55z",
    transform: "translate(-565.189 -554.456)",
    fill: "url(#corner-cover-pink_svg__aD)"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    className: "corner-cover-pink_svg__cls-85",
    d: "M-103.389-45.346l-2.58-.47c4.4-24-13.11-46.63-32.42-58.47-14.54-8.92-31.28-14.08-47.46-19.08-6.61-2-13.45-4.15-20.06-6.49-29.46-10.44-48.16-24.63-57.18-43.41-17.29-36 5.74-77.55 27.73-109.71 24.2-35.39 44.64-72.84 30.46-106.89-6.06-14.53-17.84-26-29.23-37l-2.74-2.59c-11.9-11.59-24.94-25.41-29.09-42.9-4.07-17.18 3.53-38.85 21.34-43.74l.7 2.53c-16.12 4.42-23.21 25-19.49 40.6 4 16.81 16.74 30.3 28.38 41.63l2.72 2.65c11.58 11.22 23.56 22.83 29.82 37.86 14.67 35.16-6.09 73.37-30.7 109.37-21.59 31.58-44.23 72.29-27.52 107.1 8.69 18.12 26.9 31.88 55.68 42.06 6.56 2.33 13.37 4.43 20 6.46 16.34 5.05 33.24 10.26 48.06 19.36 20.02 12.26 38.2 35.95 33.58 61.13zM55.891-78.746l-2.58-.47c4.41-24-13.1-46.63-32.41-58.47-14.55-8.92-31.28-14.08-47.46-19.08-6.62-2-13.45-4.15-20.07-6.49-29.45-10.44-48.16-24.63-57.17-43.41-17.29-36 5.73-77.55 27.73-109.7 24.2-35.4 44.63-72.85 30.46-106.9-6.06-14.53-17.84-25.95-29.24-37l-2.73-2.65c-11.9-11.59-24.95-25.41-29.09-42.9-4.08-17.18 3.53-38.85 21.34-43.74l.69 2.53c-16.11 4.42-23.2 25-19.48 40.6 4 16.81 16.73 30.3 28.37 41.63l2.73 2.65c11.58 11.22 23.56 22.83 29.82 37.86 14.67 35.21-6.09 73.38-30.71 109.38-21.59 31.58-44.24 72.29-27.53 107.1 8.7 18.12 26.91 31.88 55.68 42.06 6.57 2.33 13.38 4.43 20 6.47 16.34 5 33.23 10.26 48.06 19.35 20.04 12.31 38.22 36 33.59 61.18zM702.671 117.884l-2.58-.48c4.41-24-13.1-46.63-32.41-58.46-14.55-8.92-31.28-14.09-47.46-19.09-6.62-2-13.45-4.15-20.07-6.49-29.45-10.43-48.16-24.63-57.17-43.4-17.29-36 5.73-77.55 27.73-109.71 24.2-35.4 44.63-72.84 30.46-106.89-6.06-14.54-17.84-25.95-29.23-37l-2.74-2.64c-11.9-11.59-24.94-25.42-29.09-42.91-4.07-17.17 3.53-38.84 21.34-43.73l.69 2.52c-16.11 4.43-23.2 24.95-19.48 40.61 4 16.8 16.74 30.3 28.37 41.63l2.73 2.64c11.58 11.23 23.56 22.84 29.82 37.87 14.67 35.2-6.09 73.37-30.71 109.38-21.59 31.57-44.24 72.28-27.52 107.09 8.69 18.12 26.9 31.88 55.67 42.07 6.57 2.32 13.38 4.43 20 6.46 16.34 5 33.23 10.26 48.06 19.36 20.04 12.3 38.22 35.98 33.59 61.17z",
    fill: "#fff"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    className: "corner-cover-pink_svg__cls-85",
    d: "M770.951 157.014l-2.58-.48c4.4-24-13.11-46.62-32.41-58.46-14.55-8.92-31.28-14.08-47.46-19.08-6.62-2-13.46-4.15-20.07-6.5-29.45-10.43-48.16-24.62-57.17-43.4-17.29-36 5.73-77.55 27.73-109.71 24.2-35.39 44.63-72.84 30.45-106.89-6.05-14.54-17.83-25.95-29.23-37l-2.73-2.65c-11.9-11.59-25-25.42-29.09-42.9-4.08-17.18 3.52-38.85 21.34-43.74l.69 2.53c-16.11 4.42-23.2 24.95-19.48 40.6 4 16.81 16.73 30.3 28.37 41.63l2.73 2.65c11.58 11.22 23.56 22.83 29.82 37.86 14.66 35.21-6.1 73.38-30.71 109.38-21.59 31.58-44.24 72.29-27.53 107.1 8.7 18.12 26.91 31.88 55.68 42.06 6.57 2.33 13.38 4.43 20 6.46 16.34 5 33.23 10.26 48.06 19.36 20.04 12.31 38.22 36 33.59 61.18z",
    fill: "#fff"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    className: "corner-cover-pink_svg__cls-88",
    d: "M162.3 112.37a26.31 26.31 0 004.46-.5c2.7-.8 3.48-3.19 3.89-5.71.59-3.66-4.24-5.86-8.2-5.62-6.79.46-5.53 10.3-.15 11.83z",
    transform: "translate(-565.189 -554.456)",
    fill: "url(#corner-cover-pink_svg__aE)"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    className: "corner-cover-pink_svg__cls-89",
    d: "M211.28 271.21a18.6 18.6 0 001.73 2.57c1.35 1.39 3.06 1.11 4.73.56 2.43-.81 2.24-4.47.83-6.82-2.42-4.02-8.08-.09-7.29 3.69z",
    transform: "translate(-565.189 -554.456)",
    fill: "url(#corner-cover-pink_svg__aF)"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    className: "corner-cover-pink_svg__cls-90",
    d: "M42.27 251.38a17.12 17.12 0 002.34 1.62c1.62.76 3 0 4.28-1.07 1.84-1.49.47-4.6-1.52-6.17-3.37-2.65-7.02 2.6-5.1 5.62z",
    transform: "translate(-565.189 -554.456)",
    fill: "url(#corner-cover-pink_svg__aG)"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    className: "corner-cover-pink_svg__cls-91",
    d: "M153 81.63a16.57 16.57 0 002.82.76c1.82.16 2.87-1.1 3.72-2.53 1.23-2.07-1.16-4.56-3.62-5.36-4.25-1.37-5.86 4.92-2.92 7.13z",
    transform: "translate(-565.189 -554.456)",
    fill: "url(#corner-cover-pink_svg__aH)"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    className: "corner-cover-pink_svg__cls-92",
    d: "M326.31 210.43a24.46 24.46 0 003.68 2.08c2.51.88 4.42-.52 6.12-2.22 2.48-2.47 0-6.82-3.16-8.82-5.42-3.42-9.95 4.83-6.64 8.96z",
    transform: "translate(-565.189 -554.456)",
    fill: "url(#corner-cover-pink_svg__aI)"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    className: "corner-cover-pink_svg__cls-93",
    d: "M68 134.76a21.9 21.9 0 003.69.79c2.37.09 3.63-1.6 4.63-3.5 1.46-2.76-1.8-5.81-5-6.68-5.53-1.49-7.19 6.73-3.32 9.39z",
    transform: "translate(-565.189 -554.456)",
    fill: "url(#corner-cover-pink_svg__aJ)"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    className: "corner-cover-pink_svg__cls-94",
    d: "M79.9 311.07a27.64 27.64 0 004.77-.35c2.91-.74 3.84-3.25 4.39-5.93.78-3.88-4.28-6.43-8.51-6.33-7.26.16-6.33 10.76-.65 12.61z",
    transform: "translate(-565.189 -554.456)",
    fill: "url(#corner-cover-pink_svg__aK)"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    className: "corner-cover-pink_svg__cls-95",
    d: "M134.93 253.68a15.46 15.46 0 002.49 1c1.66.36 2.76-.67 3.7-1.89 1.37-1.75-.54-4.31-2.7-5.33-3.7-1.72-5.89 3.86-3.49 6.22z",
    transform: "translate(-565.189 -554.456)",
    fill: "url(#corner-cover-pink_svg__aL)"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    className: "corner-cover-pink_svg__cls-96",
    d: "M185.53 380.81a29.72 29.72 0 004.95.37c3.1-.31 4.43-2.75 5.4-5.4 1.4-3.86-3.39-7.25-7.75-7.8-7.47-.98-8.13 10.02-2.6 12.83z",
    transform: "translate(-565.189 -554.456)",
    fill: "url(#corner-cover-pink_svg__aM)"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    className: "corner-cover-pink_svg__cls-97",
    d: "M256.21 194.83c0 .77 1.94 4.84 2 4.89 1.75 2.8 4.7 2.93 7.68 2.6 4.33-.47 5.3-6.63 3.78-11-2.67-7.58-13.43-3.05-13.46 3.51z",
    transform: "translate(-565.189 -554.456)",
    fill: "url(#corner-cover-pink_svg__aN)"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    className: "corner-cover-pink_svg__cls-98",
    d: "M141.63 124.4a15.59 15.59 0 00.74 2.71c.75 1.59 2.3 1.84 3.9 1.85 2.32 0 3.22-3.18 2.69-5.6-.91-4.16-6.91-2.43-7.33 1.04z",
    transform: "translate(-565.189 -554.456)",
    fill: "url(#corner-cover-pink_svg__aO)"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    className: "corner-cover-pink_svg__cls-99",
    d: "M145.29 307.68a27.42 27.42 0 004.63.48c2.91-.21 4.22-2.46 5.2-4.92 1.41-3.58-3-6.88-7.06-7.51-6.97-1.08-7.88 9.27-2.77 11.95z",
    transform: "translate(-565.189 -554.456)",
    fill: "url(#corner-cover-pink_svg__aP)"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    className: "corner-cover-pink_svg__cls-100",
    d: "M250.42 277.14a23 23 0 002 3.22c1.56 1.78 3.66 1.53 5.72 1 3-.84 3-5.29 1.41-8.23-2.76-5.07-9.86-.64-9.13 4.01z",
    transform: "translate(-565.189 -554.456)",
    fill: "url(#corner-cover-pink_svg__aQ)"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    className: "corner-cover-pink_svg__cls-101",
    d: "M160.56 329.53a17.21 17.21 0 002.69 1.1c1.78.39 3-.72 4-2 1.48-1.9-.57-4.66-2.9-5.75-3.99-1.88-6.35 4.12-3.79 6.65z",
    transform: "translate(-565.189 -554.456)",
    fill: "url(#corner-cover-pink_svg__aR)"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    className: "corner-cover-pink_svg__cls-102",
    d: "M289.31 137.59a20 20 0 002.49 2.53c1.81 1.29 3.67.61 5.44-.36 2.58-1.42 1.59-5.5-.49-7.84-3.58-4.03-9.12 1.58-7.44 5.67z",
    transform: "translate(-565.189 -554.456)",
    fill: "url(#corner-cover-pink_svg__aS)"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    className: "corner-cover-pink_svg__cls-103",
    d: "M285.89 270.77a17.51 17.51 0 002.83.67c1.82.11 2.82-1.17 3.62-2.62 1.17-2.09-1.28-4.5-3.75-5.22-4.22-1.25-5.59 5.05-2.7 7.17z",
    transform: "translate(-565.189 -554.456)",
    fill: "url(#corner-cover-pink_svg__aT)"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    className: "corner-cover-pink_svg__cls-104",
    d: "M239.13 361.83a26.16 26.16 0 001.64 4.26c1.49 2.44 4 2.59 6.62 2.34 3.76-.36 4.67-5.68 3.41-9.51-2.17-6.57-11.57-2.77-11.67 2.91z",
    transform: "translate(-565.189 -554.456)",
    fill: "url(#corner-cover-pink_svg__aU)"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    className: "corner-cover-pink_svg__cls-105",
    d: "M60.92 237.16a22.87 22.87 0 003.1 2.59c2.19 1.26 4.23.29 6.13-1 2.75-1.89 1.19-6.4-1.43-8.83-4.49-4.18-10.15 2.79-7.8 7.24z",
    transform: "translate(-565.189 -554.456)",
    fill: "url(#corner-cover-pink_svg__aV)"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    className: "corner-cover-pink_svg__cls-106",
    d: "M202.65 242a18.62 18.62 0 001.91 2.45c1.45 1.31 3.14.91 4.78.24 2.38-1 1.94-4.62.36-6.88-2.7-3.91-8.09.41-7.05 4.19z",
    transform: "translate(-565.189 -554.456)",
    fill: "url(#corner-cover-pink_svg__aW)"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    className: "corner-cover-pink_svg__cls-107",
    d: "M121.2 280a17.29 17.29 0 002.34 1.78c1.65.85 3.09.07 4.43-.94 1.94-1.47.65-4.7-1.34-6.38-3.4-2.87-7.29 2.38-5.43 5.54z",
    transform: "translate(-565.189 -554.456)",
    fill: "url(#corner-cover-pink_svg__aX)"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    className: "corner-cover-pink_svg__cls-108",
    d: "M80.85 260.94c.58.51 5 1.68 5 1.69 3.29.5 5.31-1.66 7-4.16 2.47-3.62-1.59-8.39-5.95-10.11-7.44-2.95-11.04 8.26-6.05 12.58z",
    transform: "translate(-565.189 -554.456)",
    fill: "url(#corner-cover-pink_svg__aY)"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    className: "corner-cover-pink_svg__cls-109",
    d: "M269.09 243.67a15.33 15.33 0 002.21 1.33c1.52.59 2.72-.23 3.79-1.24 1.57-1.46.13-4.17-1.76-5.46-3.26-2.19-6.17 2.78-4.24 5.37z",
    transform: "translate(-565.189 -554.456)",
    fill: "url(#corner-cover-pink_svg__aZ)"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    className: "corner-cover-pink_svg__cls-110",
    d: "M125.77 225.23a20.15 20.15 0 003.54.5c2.24-.08 3.32-1.77 4.14-3.63 1.19-2.71-2.11-5.37-5.21-6-5.33-1-6.33 6.9-2.47 9.13z",
    transform: "translate(-565.189 -554.456)",
    fill: "url(#corner-cover-pink_svg__ba)"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    className: "corner-cover-pink_svg__cls-111",
    d: "M138.41 160.59c.61.5 5.11 1.63 5.17 1.64 3.37.45 5.41-1.8 7.1-4.37 2.47-3.75-1.77-8.56-6.26-10.25-7.69-2.89-11.19 8.64-6.01 12.98z",
    transform: "translate(-565.189 -554.456)",
    fill: "url(#corner-cover-pink_svg__bb)"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    className: "corner-cover-pink_svg__cls-112",
    d: "M179.43 349.47a16.53 16.53 0 002.17 1.68c1.53.79 2.88.07 4.13-.86 1.82-1.35.63-4.37-1.21-6-3.15-2.65-6.8 2.23-5.09 5.18z",
    transform: "translate(-565.189 -554.456)",
    fill: "url(#corner-cover-pink_svg__bc)"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    className: "corner-cover-pink_svg__cls-113",
    d: "M205.74 152.65a16.29 16.29 0 001.8 2.24c1.35 1.18 2.9.79 4.41.15 2.18-.93 1.72-4.29.23-6.35-2.54-3.52-7.45.54-6.44 3.96z",
    transform: "translate(-565.189 -554.456)",
    fill: "url(#corner-cover-pink_svg__bd)"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    className: "corner-cover-pink_svg__cls-114",
    d: "M293.31 201.76a18.28 18.28 0 003.18 1c2.07.26 3.3-1.14 4.32-2.73 1.49-2.31-1.15-5.23-3.91-6.23-4.73-1.75-6.8 5.34-3.59 7.96z",
    transform: "translate(-565.189 -554.456)",
    fill: "url(#corner-cover-pink_svg__be)"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    className: "corner-cover-pink_svg__cls-115",
    d: "M60.68 187.65a17.88 17.88 0 002.65 1.9c1.84.89 3.43 0 4.88-1.18 2.1-1.68.57-5.22-1.69-7-3.86-3.1-8 2.84-5.84 6.28z",
    transform: "translate(-565.189 -554.456)",
    fill: "url(#corner-cover-pink_svg__bf)"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    className: "corner-cover-pink_svg__cls-116",
    d: "M95.58 105.05a14.4 14.4 0 002.58-.19c1.57-.4 2.07-1.76 2.36-3.2.42-2.1-2.31-3.47-4.6-3.41-3.92.09-3.4 5.81-.34 6.8z",
    transform: "translate(-565.189 -554.456)",
    fill: "url(#corner-cover-pink_svg__bg)"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    className: "corner-cover-pink_svg__cls-117",
    d: "M272.69 310.67c.71.32 5.26.23 5.31.23 3.31-.44 4.66-3.09 5.61-6 1.37-4.18-3.88-7.64-8.56-8.09-8.05-.73-8.38 11.08-2.36 13.86z",
    transform: "translate(-565.189 -554.456)",
    fill: "url(#corner-cover-pink_svg__bh)"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    className: "corner-cover-pink_svg__cls-118",
    d: "M110.29 190.31a23.59 23.59 0 003 3c2.16 1.54 4.37.73 6.48-.43 3.06-1.68 1.89-6.54-.59-9.33-4.29-4.78-10.89 1.89-8.89 6.76z",
    transform: "translate(-565.189 -554.456)",
    fill: "url(#corner-cover-pink_svg__bi)"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    className: "corner-cover-pink_svg__cls-119",
    d: "M316.94 238.53a18.71 18.71 0 003.2.53c2 0 3.05-1.52 3.84-3.2 1.14-2.43-1.79-4.92-4.59-5.53-4.81-1.06-5.9 6.07-2.45 8.2z",
    transform: "translate(-565.189 -554.456)",
    fill: "url(#corner-cover-pink_svg__bj)"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    className: "corner-cover-pink_svg__cls-120",
    d: "M163.6 239.42a16.05 16.05 0 001.93 1.9c1.4 1 2.82.43 4.16-.33 1.95-1.11 1.15-4.22-.46-6-2.78-2.99-6.95 1.32-5.63 4.43z",
    transform: "translate(-565.189 -554.456)",
    fill: "url(#corner-cover-pink_svg__bk)"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    className: "corner-cover-pink_svg__cls-121",
    d: "M64.17 163a19.42 19.42 0 003.26.81c2.1.14 3.27-1.33 4.22-3 1.37-2.41-1.45-5.22-4.29-6.08-4.87-1.45-6.56 5.81-3.19 8.27z",
    transform: "translate(-565.189 -554.456)",
    fill: "url(#corner-cover-pink_svg__bl)"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    className: "corner-cover-pink_svg__cls-122",
    d: "M208.76 184.85a19.21 19.21 0 001.88 2.61c1.45 1.4 3.21 1 4.93.42 2.5-.92 2.17-4.71.63-7.09-2.65-4.1-8.38.21-7.44 4.06z",
    transform: "translate(-565.189 -554.456)",
    fill: "url(#corner-cover-pink_svg__bm)"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    className: "corner-cover-pink_svg__cls-123",
    d: "M35.05 213.74a25.05 25.05 0 003.63 2.26c2.49 1 4.48-.32 6.28-2 2.61-2.38.31-6.88-2.79-9-5.31-3.71-10.23 4.41-7.12 8.74z",
    transform: "translate(-565.189 -554.456)",
    fill: "url(#corner-cover-pink_svg__bn)"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    className: "corner-cover-pink_svg__cls-124",
    d: "M214.59 125.24a22.7 22.7 0 002.44 3.34c1.86 1.79 4.12 1.32 6.33.5 3.19-1.2 2.75-6.06.75-9.11-3.43-5.23-10.76.28-9.52 5.27z",
    transform: "translate(-565.189 -554.456)",
    fill: "url(#corner-cover-pink_svg__bo)"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    className: "corner-cover-pink_svg__cls-125",
    d: "M235.46 245.8a15.51 15.51 0 001.69 2c1.27 1 2.67.64 4 0 2-.9 1.45-3.94.05-5.77-2.39-3.14-6.75.68-5.74 3.77z",
    transform: "translate(-565.189 -554.456)",
    fill: "url(#corner-cover-pink_svg__bp)"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    className: "corner-cover-pink_svg__cls-126",
    d: "M179.7 296.42a23.34 23.34 0 003.81-.63c2.28-.8 2.84-2.88 3.09-5.07.35-3.16-3.89-4.84-7.28-4.46-5.81.65-4.32 9.08.38 10.16z",
    transform: "translate(-565.189 -554.456)",
    fill: "url(#corner-cover-pink_svg__bq)"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    className: "corner-cover-pink_svg__cls-127",
    d: "M207.33 84a17.25 17.25 0 001.72 2.32c1.32 1.25 2.9.91 4.44.32 2.24-.85 1.9-4.25.48-6.38-2.42-3.68-7.53.22-6.64 3.74z",
    transform: "translate(-565.189 -554.456)",
    fill: "url(#corner-cover-pink_svg__br)"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    className: "corner-cover-pink_svg__cls-128",
    d: "M110.29 156.87a21.13 21.13 0 00.73 3.71c.85 2.21 2.91 2.7 5 2.87 3.11.25 4.63-4 4.16-7.26-.77-5.67-8.98-3.94-9.89.68z",
    transform: "translate(-565.189 -554.456)",
    fill: "url(#corner-cover-pink_svg__bs)"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    className: "corner-cover-pink_svg__cls-129",
    d: "M266.6 163.71a15.88 15.88 0 00.79 2.61c.77 1.52 2.28 1.72 3.83 1.69 2.26 0 3-3.17 2.46-5.51-.99-4.01-6.76-2.17-7.08 1.21z",
    transform: "translate(-565.189 -554.456)",
    fill: "url(#corner-cover-pink_svg__bt)"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    className: "corner-cover-pink_svg__cls-130",
    d: "M86.54 171.8a16.21 16.21 0 001 2.71c.94 1.55 2.56 1.64 4.21 1.48 2.38-.23 3-3.61 2.15-6.05-1.33-4.17-7.3-1.75-7.36 1.86z",
    transform: "translate(-565.189 -554.456)",
    fill: "url(#corner-cover-pink_svg__bu)"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    className: "corner-cover-pink_svg__cls-131",
    d: "M219.39 338a18 18 0 002.88 1.31c1.93.48 3.26-.68 4.42-2.06 1.69-2-.45-5.09-2.94-6.37-4.27-2.17-7.08 4.29-4.36 7.12z",
    transform: "translate(-565.189 -554.456)",
    fill: "url(#corner-cover-pink_svg__bv)"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    className: "corner-cover-pink_svg__cls-132",
    d: "M317.94 262.88a25.42 25.42 0 003.56 2.54c2.48 1.19 4.6 0 6.54-1.59 2.83-2.26.77-7-2.26-9.43-5.19-4.13-10.78 3.85-7.84 8.48z",
    transform: "translate(-565.189 -554.456)",
    fill: "url(#corner-cover-pink_svg__bw)"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    className: "corner-cover-pink_svg__cls-133",
    d: "M237.07 102.33a24.68 24.68 0 004.23 0c2.61-.46 3.6-2.62 4.25-4.94.94-3.36-3.35-5.94-7.09-6.13-6.4-.33-6.27 9.07-1.39 11.07z",
    transform: "translate(-565.189 -554.456)",
    fill: "url(#corner-cover-pink_svg__bx)"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    className: "corner-cover-pink_svg__cls-134",
    d: "M290.84 230.68a27.13 27.13 0 004.32.95c2.77.11 4.26-1.87 5.44-4.09 1.73-3.22-2.08-6.82-5.85-7.85-6.47-1.77-8.45 7.85-3.91 10.99z",
    transform: "translate(-565.189 -554.456)",
    fill: "url(#corner-cover-pink_svg__by)"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    className: "corner-cover-pink_svg__cls-135",
    d: "M312.7 176.22a17.9 17.9 0 003 .89c2 .22 3.13-1.13 4.09-2.66 1.38-2.22-1.16-5-3.81-5.89-4.49-1.56-6.37 5.21-3.28 7.66z",
    transform: "translate(-565.189 -554.456)",
    fill: "url(#corner-cover-pink_svg__bz)"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    className: "corner-cover-pink_svg__cls-136",
    d: "M153.37 215.18a17.49 17.49 0 002.06 2c1.49 1 3 .45 4.43-.37 2.08-1.18 1.22-4.49-.5-6.38-2.96-3.2-7.36 1.44-5.99 4.75z",
    transform: "translate(-565.189 -554.456)",
    fill: "url(#corner-cover-pink_svg__bA)"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    className: "corner-cover-pink_svg__cls-137",
    d: "M107.35 321.84a21 21 0 003.32 1.33c2.2.46 3.65-.92 4.89-2.53 1.81-2.35-.75-5.73-3.63-7.05-4.93-2.28-7.79 5.14-4.58 8.25z",
    transform: "translate(-565.189 -554.456)",
    fill: "url(#corner-cover-pink_svg__bB)"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    className: "corner-cover-pink_svg__cls-138",
    d: "M244.13 221.67c.67.37 5.14.58 5.19.58 3.27-.22 4.77-2.73 5.89-5.48 1.62-4-3.3-7.75-7.86-8.49-7.82-1.28-8.94 10.28-3.22 13.39z",
    transform: "translate(-565.189 -554.456)",
    fill: "url(#corner-cover-pink_svg__bC)"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    className: "corner-cover-pink_svg__cls-139",
    d: "M39.73 154.86a13.72 13.72 0 00.64 2.46c.65 1.45 2.05 1.7 3.49 1.73 2.1 0 3-2.83 2.51-5-.76-3.79-6.2-2.32-6.64.81z",
    transform: "translate(-565.189 -554.456)",
    fill: "url(#corner-cover-pink_svg__bD)"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    className: "corner-cover-pink_svg__cls-140",
    d: "M208.75 368.66c.77.19 5.31-.78 5.36-.79 3.23-1.08 4.06-4 4.45-7.06.57-4.44-5.36-6.89-10.13-6.43-8.17.79-6.24 12.67.32 14.28z",
    transform: "translate(-565.189 -554.456)",
    fill: "url(#corner-cover-pink_svg__bE)"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    className: "corner-cover-pink_svg__cls-141",
    d: "M173.42 185.35c.44.56 4.22 2.32 4.27 2.34 2.9 1 5.08-.66 7-2.64 2.82-2.88-.1-7.85-3.77-10.11-6.27-3.87-11.33 5.7-7.5 10.41z",
    transform: "translate(-565.189 -554.456)",
    fill: "url(#corner-cover-pink_svg__bF)"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    className: "corner-cover-pink_svg__cls-142",
    d: "M153.48 278a23.3 23.3 0 003.66 1.63c2.45.61 4.13-.87 5.59-2.63 2.13-2.55-.6-6.44-3.76-8.05-5.42-2.8-8.97 5.39-5.49 9.05z",
    transform: "translate(-565.189 -554.456)",
    fill: "url(#corner-cover-pink_svg__bG)"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    className: "corner-cover-pink_svg__cls-143",
    d: "M304.79 295.69a27.21 27.21 0 004.22 1.79c2.8.65 4.7-1.08 6.33-3.11 2.38-3-.81-7.35-4.46-9.13-6.24-3.05-10.11 6.38-6.09 10.45z",
    transform: "translate(-565.189 -554.456)",
    fill: "url(#corner-cover-pink_svg__bH)"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    className: "corner-cover-pink_svg__cls-144",
    d: "M114.32 117a26.3 26.3 0 001.07 4.35c1.14 2.57 3.61 3 6.16 3.12 3.7.12 5.26-4.95 4.51-8.84-1.29-6.69-10.92-4.17-11.74 1.37z",
    transform: "translate(-565.189 -554.456)",
    fill: "url(#corner-cover-pink_svg__bI)"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    className: "corner-cover-pink_svg__cls-145",
    d: "M69.84 211.75a22.32 22.32 0 003 2.47c2.14 1.19 4.1.22 5.92-1.06 2.64-1.86 1.07-6.21-1.49-8.53-4.37-3.97-9.76 2.84-7.43 7.12z",
    transform: "translate(-565.189 -554.456)",
    fill: "url(#corner-cover-pink_svg__bJ)"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    className: "corner-cover-pink_svg__cls-146",
    d: "M213.74 296.28a26.3 26.3 0 001.31 4.32c1.29 2.53 3.79 2.87 6.36 2.82 3.74-.08 5-5.26 4.08-9.14-1.65-6.65-11.22-3.61-11.75 2z",
    transform: "translate(-565.189 -554.456)",
    fill: "url(#corner-cover-pink_svg__bK)"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    className: "corner-cover-pink_svg__cls-147",
    d: "M128.24 335.76a21 21 0 00.94 3.48c1 2.05 3 2.38 5 2.41 3 0 4.15-4.08 3.48-7.2-1.14-5.35-8.86-3.16-9.42 1.31z",
    transform: "translate(-565.189 -554.456)",
    fill: "url(#corner-cover-pink_svg__bL)"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    className: "corner-cover-pink_svg__cls-148",
    d: "M238.32 308.1a23.84 23.84 0 002.48 3.08c1.87 1.63 4 1.08 6.08.2 3-1.29 2.37-5.92.32-8.75-3.52-4.86-10.28.74-8.88 5.47z",
    transform: "translate(-565.189 -554.456)",
    fill: "url(#corner-cover-pink_svg__bM)"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    className: "corner-cover-pink_svg__cls-149",
    d: "M207 215.41a16.28 16.28 0 002.26 1.67c1.58.79 3 0 4.22-1 1.84-1.43.56-4.5-1.36-6.08-3.27-2.67-6.92 2.41-5.12 5.41z",
    transform: "translate(-565.189 -554.456)",
    fill: "url(#corner-cover-pink_svg__bN)"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    className: "corner-cover-pink_svg__cls-150",
    d: "M103.65 243a26.4 26.4 0 001.45 4.51c1.38 2.62 4 2.94 6.71 2.84 3.92-.15 5.19-5.6 4.12-9.66-1.84-6.93-11.82-3.57-12.28 2.31z",
    transform: "translate(-565.189 -554.456)",
    fill: "url(#corner-cover-pink_svg__bO)"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    className: "corner-cover-pink_svg__cls-151",
    d: "M92.67 287.22a22.65 22.65 0 003.77.48c2.37-.12 3.49-1.93 4.33-3.92 1.22-2.89-2.31-5.66-5.61-6.25-5.67-1.01-6.61 7.37-2.49 9.69z",
    transform: "translate(-565.189 -554.456)",
    fill: "url(#corner-cover-pink_svg__bP)"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    className: "corner-cover-pink_svg__cls-152",
    d: "M123.53 90.6a25.08 25.08 0 003.28 2.9c2.34 1.43 4.57.44 6.67-.91 3-2 1.48-6.9-1.29-9.61-4.73-4.64-11.07 2.73-8.66 7.62z",
    transform: "translate(-565.189 -554.456)",
    fill: "url(#corner-cover-pink_svg__bQ)"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    className: "corner-cover-pink_svg__cls-153",
    d: "M96.65 137.63a14.19 14.19 0 001.94 1.66c1.38.81 2.67.21 3.87-.6 1.76-1.17.8-4-.84-5.58-2.81-2.66-6.42 1.7-4.97 4.52z",
    transform: "translate(-565.189 -554.456)",
    fill: "url(#corner-cover-pink_svg__bR)"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    className: "corner-cover-pink_svg__cls-154",
    d: "M174.91 143.05a15.64 15.64 0 002.54-.05c1.56-.31 2.13-1.61 2.5-3 .53-2-2.07-3.53-4.32-3.6-3.84-.14-3.63 5.5-.72 6.65z",
    transform: "translate(-565.189 -554.456)",
    fill: "url(#corner-cover-pink_svg__bS)"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    className: "corner-cover-pink_svg__cls-155",
    d: "M95.69 220.6a26.64 26.64 0 004.52 1.4c3 .38 4.72-1.6 6.19-3.86 2.14-3.29-1.6-7.47-5.54-8.92-6.74-2.49-9.73 7.61-5.17 11.38z",
    transform: "translate(-565.189 -554.456)",
    fill: "url(#corner-cover-pink_svg__bT)"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    className: "corner-cover-pink_svg__cls-156",
    d: "M145.86 187.89a20 20 0 002 2.7c1.51 1.45 3.35 1.07 5.13.41 2.59-1 2.23-4.91.61-7.38-2.81-4.24-8.74.22-7.74 4.27z",
    transform: "translate(-565.189 -554.456)",
    fill: "url(#corner-cover-pink_svg__bU)"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    className: "corner-cover-pink_svg__cls-157",
    d: "M252.22 119.74a16 16 0 001.84 1.72c1.33.86 2.63.32 3.85-.42 1.78-1.08 1-4-.59-5.55-2.65-2.74-6.41 1.4-5.1 4.25z",
    transform: "translate(-565.189 -554.456)",
    fill: "url(#corner-cover-pink_svg__bV)"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    className: "corner-cover-pink_svg__cls-158",
    d: "M27.24 184.42a13.32 13.32 0 001.45 2c1.11 1 2.44.76 3.74.27 1.87-.72 1.59-3.58.4-5.37-2.05-3.12-6.34.17-5.59 3.1z",
    transform: "translate(-565.189 -554.456)",
    fill: "url(#corner-cover-pink_svg__bW)"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    className: "corner-cover-pink_svg__cls-159",
    d: "M281.86 330.9a21.79 21.79 0 001.19 3.44c1.12 2 3.15 2.19 5.22 2.07 3-.17 3.9-4.39 3-7.49-1.53-5.31-9.15-2.56-9.41 1.98z",
    transform: "translate(-565.189 -554.456)",
    fill: "url(#corner-cover-pink_svg__bX)"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    className: "corner-cover-pink_svg__cls-160",
    d: "M55 279c.18.76 3.07 4.31 3.11 4.35 2.39 2.34 5.32 1.77 8.19.74 4.16-1.5 3.65-7.81 1.1-11.79-4.4-6.87-13.98.16-12.4 6.7z",
    transform: "translate(-565.189 -554.456)",
    fill: "url(#corner-cover-pink_svg__bY)"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    className: "corner-cover-pink_svg__cls-161",
    d: "M192.64 111.71a24.53 24.53 0 002.5 3.16c1.9 1.67 4.08 1.14 6.2.25 3.08-1.28 2.46-6 .4-8.92-3.55-4.98-10.49.68-9.1 5.51z",
    transform: "translate(-565.189 -554.456)",
    fill: "url(#corner-cover-pink_svg__bZ)"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    className: "corner-cover-pink_svg__cls-162",
    d: "M191.85 320.79a18.15 18.15 0 003.25-.1c2-.41 2.7-2.09 3.15-3.88.65-2.61-2.71-4.49-5.58-4.55-4.93-.11-4.61 7.11-.82 8.53z",
    transform: "translate(-565.189 -554.456)",
    fill: "url(#corner-cover-pink_svg__ca)"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    className: "corner-cover-pink_svg__cls-163",
    d: "M176.9 84.93c.32.72 3.86 3.73 3.91 3.76 2.83 1.9 5.65.78 8.32-.78 3.87-2.27 2.19-8.48-1.09-12-5.63-5.98-13.88 2.82-11.14 9.02z",
    transform: "translate(-565.189 -554.456)",
    fill: "url(#corner-cover-pink_svg__cb)"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    className: "corner-cover-pink_svg__cls-164",
    d: "M252.65 335.65a18.67 18.67 0 002.64 1.72c1.81.76 3.3-.18 4.64-1.36 2-1.72.32-5.06-1.93-6.7-3.86-2.8-7.59 3.12-5.35 6.34z",
    transform: "translate(-565.189 -554.456)",
    fill: "url(#corner-cover-pink_svg__cc)"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    className: "corner-cover-pink_svg__cls-165",
    d: "M178.71 262.52c.15.74 2.86 4.26 2.89 4.3 2.26 2.33 5.12 1.86 7.92.93 4.07-1.34 3.75-7.47 1.39-11.39-4.06-6.74-13.52-.17-12.2 6.16z",
    transform: "translate(-565.189 -554.456)",
    fill: "url(#corner-cover-pink_svg__cd)"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    className: "corner-cover-pink_svg__cls-166",
    d: "M149 361.92a26.13 26.13 0 003 3.45c2.21 1.8 4.66 1.09 7 0 3.41-1.59 2.5-6.9 0-10.08-4.27-5.47-11.85 1.24-10 6.63z",
    transform: "translate(-565.189 -554.456)",
    fill: "url(#corner-cover-pink_svg__ce)"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    className: "corner-cover-pink_svg__cls-167",
    d: "M243.43 155.29a17.49 17.49 0 002.78-.22c1.7-.45 2.23-1.92 2.54-3.48.45-2.27-2.52-3.74-5-3.67-4.22.08-3.65 6.31-.32 7.37z",
    transform: "translate(-565.189 -554.456)",
    fill: "url(#corner-cover-pink_svg__cf)"
  })));
}

export default __webpack_public_path__ + "static/corner-cover-pink.718adbb9.svg";
export { SvgCornerCoverPink as ReactComponent };